import { render, staticRenderFns } from "./login.vue?vue&type=template&id=1aec3c45&"
import script from "./login.vue?vue&type=script&lang=js&"
export * from "./login.vue?vue&type=script&lang=js&"
import style0 from "./login.vue?vue&type=style&index=0&id=1aec3c45&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/nuxt-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aec3c45')) {
      api.createRecord('1aec3c45', component.options)
    } else {
      api.reload('1aec3c45', component.options)
    }
    module.hot.accept("./login.vue?vue&type=template&id=1aec3c45&", function () {
      api.rerender('1aec3c45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "layouts/login.vue"
export default component.exports